/* eslint-disable */
import React from "react";
import Icon from "../Icon";
const OutlineMediaIcHeadphonesMic = props => {
  const {
    color,
    size,
    width,
    height,
    customColor,
    className,
    dataTest,
    ariaHidden,
    ariaLabel,
    reverseOnRtl
  } = props;
  return React.createElement(Icon, {
    viewBox: "0 0 24 24",
    size: size,
    width: width,
    height: height,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M5.6 16.468V17.6a3.2 3.2 0 003.2 3.2H12M5.6 9.125V8.8a5.6 5.6 0 015.6-5.6h1.6a5.6 5.6 0 015.6 5.6v.338"
  }), React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M8 8.88a4 4 0 100 7.838V8.882zm8 7.839a4 4 0 100-7.838v7.838z"
  }));
};
export default OutlineMediaIcHeadphonesMic;